import { render, staticRenderFns } from "./ShippingCostHead.vue?vue&type=template&id=29061436&scoped=true"
import script from "./ShippingCostHead.vue?vue&type=script&lang=js"
export * from "./ShippingCostHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29061436",
  null
  
)

export default component.exports